module.exports = "/_next/static/images/ce029190f7ece80f1e0bc53fecc717b4-roxinho-details-metalico-lg@2x.jpg";